"use strict";

var _Promise = _interopRequireDefault(require("./promise/Promise.js"));

var _array = _interopRequireDefault(require("array.from"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function bind(that) {
  var self = this,
      args = arguments.length > 1 ? Array.prototype.slice.call(arguments, 1) : null,
      F = function F() {};

  var bound = function bound() {
    var context = that,
        length = arguments.length;

    if (this instanceof bound) {
      F.prototype = self.prototype;
      context = new F();
    }

    var result = !args && !length ? self.call(context) : self.apply(context, args && length ? args.concat(Array.prototype.slice.call(arguments, 0)) : args || arguments);
    return context == that ? result : context;
  };

  return bound;
}

if (!window.Promise) {
  window.Promise = _Promise["default"];
}

if (!window.Array.from) {
  window.Array.from = _array["default"];
}

if (!Array.prototype.map) {
  Array.prototype.map = function (fn) {
    var results = [],
        i,
        item;

    for (i = 0; item = this[i]; i++) {
      results[i] = fn(item);
    }

    return results;
  };
}

if (false === 'bind' in Function.prototype) {
  Function.prototype.bind = bind;
}

window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback, element) {
    // 17 is 1000ms / 60Hz
    return window.setTimeout(callback, 17);
  };
}();

window.cancelRequestAnimFrame = function () {
  return window.cancelRequestAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout;
}();

if ('requestAnimationFrame' in window == false) {
  window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function (callback, element) {
    // 17 is 1000ms / 60Hz
    return window.setTimeout(callback, 17);
  };
}

if ('cancelAnimationFrame' in window == false) {
  window.cancelAnimationFrame = window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.msCancelAnimationFrame || window.oCancelAnimationFrame || function (handle) {
    clearTimeout(handle);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@chegg/ereader-core/dist/utils.polyfills.js
// module id = 508
// module chunks = 0